// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2SUxC","col":"CardReaderDesc_col__ulUaa","label":"CardReaderDesc_label__2gLfx"};